import { render, staticRenderFns } from "./InsuranceBlock.vue?vue&type=template&id=19177183&scoped=true"
import script from "./InsuranceBlock.vue?vue&type=script&lang=js"
export * from "./InsuranceBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19177183",
  null
  
)

export default component.exports